// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#options-menu .menu-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    background-color: transparent;
    border: none;
    color: var(--main-foreground-color);
    font-size: 1rem;
    padding: 0.75rem 0.25rem;
    cursor: pointer;
    text-align: start;
}

#options-menu .menu-item + .menu-item {
    border-top: 1px solid rgba(93, 189, 232, 0.2);
}

#options-menu .menu-item svg {
    color: var(--secondary-color);
    flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/OptionsMenu.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,mCAAmC;IACnC,eAAe;IACf,wBAAwB;IACxB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB","sourcesContent":["#options-menu .menu-item {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    background-color: transparent;\n    border: none;\n    color: var(--main-foreground-color);\n    font-size: 1rem;\n    padding: 0.75rem 0.25rem;\n    cursor: pointer;\n    text-align: start;\n}\n\n#options-menu .menu-item + .menu-item {\n    border-top: 1px solid rgba(93, 189, 232, 0.2);\n}\n\n#options-menu .menu-item svg {\n    color: var(--secondary-color);\n    flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
